module.exports = __webpack_public_path__ + "img/Streeme-Logo.83f76f.svg";